import React, { Component, Fragment } from 'react';
import {
    Icon, Layout, Breadcrumb, Steps, message, Checkbox, Spin,
} from 'antd';
import { Link, Redirect } from 'react-router-dom';
import mongoose from 'mongoose';
import { connect } from 'react-redux';
import { SFButton } from '../../../components/SF-UI';
import BikeInfo from './components/BikeInfo';
import CustomerInfo from './components/CustomerInfo';
import BikeCondition from './components/BikeCondition';
import PartExInfo from './components/PartExInfo';
import { Lead_create_schema } from './schema/mongooseSchema';
import { createLeadRequest } from './redux/actions/create_lead.actions';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';

// Event delegate on field with attribute [db_key]
EventTarget.prototype.on = function (type, selector, callback) {
    function event_callback(event) {
        if (event.target.matches(selector)) {
            callback.call(this, event);
        }
    }

    if (!this._events) {
        this._events = {};
    }
    if (!this._events[`${type}/${selector}`]) {
        this._events[`${type}/${selector}`] = [];
    }
    this._events[`${type}/${selector}`].push(event_callback);
    return this.addEventListener(type, event_callback);
};

EventTarget.prototype.off = function (type, selector) {
    if (!this._events) {
        this._events = {};
    }
    if (this._events[`${type}/${selector}`]) {
        this._events[`${type}/${selector}`].forEach((fn) => this.removeEventListener(type, fn));

        delete this._events[`${type}/${selector}`];
    }
    return this;
};


const { Content } = Layout;
const { Step } = Steps;
const stepStyles = {
    stepsContent: {
        marginTop: 16,
        padding: '10px 15px 0',
        border: '1px dashed #e9e9e9',
        borderRadius: 6,
        backgroundColor: '#fafafa',
        minHeight: 350,
        position: 'relative',
    },
    stepsAction: {
        marginTop: 24,
    },
};

class LeadCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            is_part_ex: false,
        };

        this.Lead_create_data = new mongoose.Document({}, Lead_create_schema);
    }

    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    componentDidMount() {
        // To disabled submit button at the beginning.
        this.props.dispatch({ type: 'GET_LEAD_CREATE_CATALOGS_SAGA' });
    }

    next = () => {
        this.Lead_create_data.errors = {};
        this.Lead_create_data.set({ 'ref_bike_lead.unmaped_data.bike_year': this.Lead_create_data.ref_bike_lead.bike_year });
        this.Lead_create_data.set({ 'ref_bike_lead.temporary.bike_year': this.Lead_create_data.ref_bike_lead.bike_year });
        const validation_result = this.Lead_create_data.validateSync();

        if (validation_result !== undefined) {
            const ref_bike_lead_result = Object.keys(validation_result.errors).every(error => error.indexOf('ref_bike_lead') === -1);
            const ref_lead_customer_result = Object.keys(validation_result.errors).every(error => error.indexOf('ref_lead_customer') === -1);

            if (this.state.current === 0 && ref_bike_lead_result === true) {
                this.setState((state) => ({ ...state, current: state.current + 1 }));
            } else if (this.state.current === 0 && ref_lead_customer_result === true) {
                this.setState((state) => ({ ...state, current: state.current + 1 }));
            } else {
                message.error('Please, fill all required fields');
            }
        } else {
            this.setState((state) => ({ ...state, current: state.current + 1 }));
        }
    };

    prev = () => {
        const current = this.state.current - 1;
        this.setState({ current });
    };

    finishCreate = () => {
        this.Lead_create_data.errors = {};
        const validation_result = this.Lead_create_data.validateSync();
        if (validation_result === undefined) {
            this.props.dispatch(createLeadRequest(this.Lead_create_data.toJSON()));
        } else {
            message.error('Check please required fields');
        }
    };

    isPartExchange = (e) => {
        this.Lead_create_data.set({ 'part_ex.is_part_ex': e.target.checked });
        (this.state.current === 2)
            ? this.setState({ current: 1 })
            : this.forceUpdate();
    };

    buildStepContent = () => {
        const steps = [
            {
                title: 'Bike info',
                icon: undefined,
                content: <Fragment>
                    <BikeInfo Lead_create_data={this.Lead_create_data} parent={this} />
                    <BikeCondition Lead_create_data={this.Lead_create_data} catalogs={this.props.catalogs} />
                </Fragment>,
            },
            {
                title: 'Customer info',
                icon: 'solution',
                content: <CustomerInfo Lead_create_data={this.Lead_create_data} />,
            },
        ];

        if (this.Lead_create_data.part_ex.is_part_ex) {
            steps.push({
                title: 'Part exchange info',
                content: <PartExInfo Lead_create_data={this.Lead_create_data} />,
            });
        }

        return steps;
    };

    render() {
        const { current } = this.state;
        const stepContent = this.buildStepContent();

        const { views_permissions } = this.props;
        const lead_create_access = views_permissions['view://Leads/Lead_create'];

        if (!lead_create_access) {
            return <NotFound />;
        }

        return (
            <Layout>
                <Breadcrumb className="breadcrumbs">
                    <Breadcrumb.Item><Link to="/Leads/Manage">Leads</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Add New Lead</Breadcrumb.Item>
                </Breadcrumb>
                <Spin spinning={this.props.loading} tip="Creating Lead...">
                    <Content
                        style={{
                            background: '#fff', padding: 24, margin: 0, minHeight: 280,
                        }}
                        className="border-shadows"
                    >
                        <div style={{ margin: '5px 0 20px 5px' }}>
                            <Checkbox
                                defaultChecked={this.Lead_create_data.part_ex.is_part_ex}
                                onChange={this.isPartExchange}
                            >
                                Click if Part Exchange lead
                            </Checkbox>
                        </div>
                        <div>
                            <Steps current={current}>
                                {
                                    stepContent.map((item) => (
                                        <Step
                                            key={item.title}
                                            title={item.title}
                                            icon={item.icon && <Icon type={item.icon} />}
                                        />
                                    ))
                                }
                            </Steps>
                            <div className="steps-content" style={stepStyles.stepsContent}>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                    {stepContent[current].content}
                                </div>
                            </div>
                            <div className="steps-action" style={stepStyles.stepsAction}>
                                <div className="sf-btn-toolbar">
                                    {
                                        current < stepContent.length - 1
                                        && <SFButton type="primary" onClick={this.next}>Next</SFButton>
                                    }
                                    {
                                        current === stepContent.length - 1
                                        && <SFButton type="primary" onClick={this.finishCreate}>Done</SFButton>
                                    }
                                    {
                                        current > 0
                                        && (
                                            <SFButton style={{ marginRight: 8 }} onClick={this.prev}>
                                                Previous
                                            </SFButton>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Content>
                </Spin>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    views_permissions: state.App.Permissions.views_permissions,
    loading: state.Leads.Lead_create.loading,
    catalogs: state.Leads.Lead_create.catalogs,
});

export default connect(mapStateToProps, null)(checkPermissionsHOC(LeadCreate, ['view://Leads/Lead_create']));



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/index.js